import type { GroupByUuidResponse } from "@/common/api/group/use-group-by-uuid.query";
import { ApplicationAppRoleTable } from "@/components/data-table/predefined/application-app-role-table/application-app-role-table";
import { DataTableHeightMode } from "@/components/data-table/types";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export function AppRolesTab({ group, canManage }: { group: GroupByUuidResponse; canManage: boolean }): ReactElement {
  const { t } = useTranslation("ram");

  return (
    <div className="flex w-full flex-col gap-5">
      <div>
        <h2 className="text-lg leading-none font-semibold">{t("ram:AppRoles")}</h2>
        <p className="text-muted-foreground mt-1 text-sm">{t("ram:ManageApplicationAppRolesForThisGroup")}</p>
      </div>
      <ApplicationAppRoleTable
        selected={group.appRoles ?? []}
        showCreateButton={canManage}
        createButtonLink={`~/ram/group/${group.uuid}/app-role`}
        heightMode={DataTableHeightMode.Content}
      />
    </div>
  );
}
